'use client';

import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import TermsAndPrivacy from './components/terms-and-privacy-content';
import { Button } from '@/components/ui/button';

export default function TermsAndPrivacyPage() {
  const router = useRouter();

  return (
    <div>
      <div className="sticky top-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
        <div className="container mx-auto max-w-7xl px-4 py-4">
          <Button 
            variant="ghost" 
            onClick={() => router.back()}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        </div>
      </div>
      <TermsAndPrivacy />
    </div>
  );
}